import { type MutationError, trpc } from '@/shared/api';

interface UseRenameExhibitionPurposeOptions {
  readonly onSuccess?: () => void;
}

/** 목적 탭 이름을 바꾼다. 이름이 겹치면 서버가 거부한다. */
export const useRenameExhibitionPurpose = ({
  onSuccess,
}: UseRenameExhibitionPurposeOptions = {}) => {
  const mutation = trpc.productManagement.exhibitionPurposes.rename.useMutation({ onSuccess });
  const error: MutationError | null = mutation.error;

  return {
    renamePurpose: (id: string, name: string) => mutation.mutate({ id, name }),
    isPending: mutation.isPending,
    error,
    reset: mutation.reset,
  };
};
